var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Prop, Component, Mixins } from 'vue-property-decorator';
import { ValidationProvider } from 'vee-validate';
import { Savable } from '@/common/mixins/Savable';
import { Validatable } from '@/common/mixins/Validatable';
import { NumericSanitizeable } from '@/common/mixins/NumericSanitizeable';
import { Focusable } from '@/common/mixins/Focusable';
var NumericInputControl = /** @class */ (function (_super) {
    __extends(NumericInputControl, _super);
    function NumericInputControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // This is used as a flag when screen reader blurs and refocuses the element
        // when user presses enter/space on given input to enter focus mode (to actually type something).
        // Without this flag focus is lost altogether for screen reader users!
        _this.componentBlurred = true;
        _this.showNumeric = false;
        return _this;
    }
    NumericInputControl_1 = NumericInputControl;
    Object.defineProperty(NumericInputControl.prototype, "isFirefox68", {
        // TODO: Refactor, this does not belong here (remember to refactor NumericInputControl as well)
        get: function () {
            if (NumericInputControl_1.ff68 == undefined) {
                var browser = this.browserSpecs;
                if (browser && browser.name == "Firefox" && (browser.version == "60" || browser.version == "66" || browser.version == "67" || browser.version == "68" || browser.version == "71" || browser.version == "72" || browser.version == "73")) {
                    NumericInputControl_1.ff68 = true;
                }
                else {
                    NumericInputControl_1.ff68 = false;
                }
            }
            return NumericInputControl_1.ff68;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NumericInputControl.prototype, "showNumericOrFF", {
        get: function () {
            return this.showNumeric || this.isFirefox68 || !this.formatting;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NumericInputControl.prototype, "browserSpecs", {
        // TODO: Refactor, this does not belong here (remember to refactor NumericInputControl as well)
        get: function () {
            var ua = navigator.userAgent, tem, M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
            if (/trident/i.test(M[1])) {
                tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
                return { name: 'IE', version: (tem[1] || '') };
            }
            if (M[1] === 'Chrome') {
                tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
                if (tem != null)
                    return { name: tem[1].replace('OPR', 'Opera'), version: tem[2] };
            }
            M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
            if ((tem = ua.match(/version\/(\d+)/i)) != null)
                M.splice(1, 1, tem[1]);
            return { name: M[0], version: M[1] };
        },
        enumerable: false,
        configurable: true
    });
    NumericInputControl.prototype.handleKeydown = function (event) {
        if (!event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) {
            if (this.minValue < 0) {
                this.sanitize(event);
            }
            else {
                this.sanitizePositive(event);
            }
            this.change();
        }
    };
    NumericInputControl.prototype.focused = function () {
        if (!this.isDisabled) {
            this.componentBlurred = false;
            this.showNumeric = true;
        }
        this.touch();
    };
    NumericInputControl.prototype.blurred = function () {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.isDisabled) return [3 /*break*/, 2];
                        this.componentBlurred = true;
                        return [4 /*yield*/, this.delay(1)];
                    case 1:
                        _a.sent();
                        // In case of a screen reader refocus, we do not want to set showNumeric to false (focus still exists).
                        // After the 1ms delay, componentBlurred should be true only if it wasn't a screen reader refocus.
                        if (this.componentBlurred) {
                            this.showNumeric = false;
                        }
                        _a.label = 2;
                    case 2:
                        if (this.componentBlurred) {
                            this.blur();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    NumericInputControl.prototype.preventWheel = function (event) {
        if (event.target == document.activeElement)
            event.preventDefault();
    };
    Object.defineProperty(NumericInputControl.prototype, "defaultRules", {
        get: function () {
            return { required: this.required, min_value: this.minValue, max_value: this.maxValue };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NumericInputControl.prototype, "mergedRules", {
        get: function () {
            return Object.assign({}, this.defaultRules, this.rules);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NumericInputControl.prototype, "modifiedValue", {
        get: function () {
            return this.value;
        },
        set: function (modified) {
            var num;
            if (this.minValue < 0) {
                num = this.cleanInt(modified, false);
            }
            else {
                num = this.cleanInt(modified, true);
            }
            if (num > this.maxValue) {
                num = this.maxValue;
            }
            this.$emit("input", num);
            this.$root.$emit("numericInputValueChanged");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NumericInputControl.prototype, "modifiedValueStr", {
        get: function () {
            return this.$options.filters.formatNumber(this.modifiedValue);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NumericInputControl.prototype, "isDisabled", {
        get: function () {
            return Boolean(this.$attrs.disabled) || this.isReadOnly;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NumericInputControl.prototype, "placeholder", {
        get: function () {
            if (this.isDisabled) {
                return '';
            }
            else if (this.placeholderKey) {
                return this.$t(this.placeholderKey).toString();
            }
            else {
                return this.$t("EnterValue").toString();
            }
        },
        enumerable: false,
        configurable: true
    });
    var NumericInputControl_1, _a;
    __decorate([
        Prop(Number),
        __metadata("design:type", Object)
    ], NumericInputControl.prototype, "value", void 0);
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], NumericInputControl.prototype, "placeholderKey", void 0);
    __decorate([
        Prop({ type: Number, default: 0 }),
        __metadata("design:type", Number)
    ], NumericInputControl.prototype, "minValue", void 0);
    __decorate([
        Prop({ type: Number, default: 1000000000 }),
        __metadata("design:type", Number)
    ], NumericInputControl.prototype, "maxValue", void 0);
    __decorate([
        Prop({ type: Boolean, default: false }),
        __metadata("design:type", Boolean)
    ], NumericInputControl.prototype, "required", void 0);
    __decorate([
        Prop(Object),
        __metadata("design:type", typeof (_a = typeof Object !== "undefined" && Object) === "function" ? _a : Object)
    ], NumericInputControl.prototype, "rules", void 0);
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], NumericInputControl.prototype, "id", void 0);
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], NumericInputControl.prototype, "labelledBy", void 0);
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], NumericInputControl.prototype, "name", void 0);
    __decorate([
        Prop({ type: Boolean, default: true }),
        __metadata("design:type", Boolean)
    ], NumericInputControl.prototype, "formatting", void 0);
    NumericInputControl = NumericInputControl_1 = __decorate([
        Component({
            name: 'NumericInputControl',
            components: {
                ValidationProvider: ValidationProvider
            },
            inheritAttrs: false
        })
    ], NumericInputControl);
    return NumericInputControl;
}(Mixins(Savable, Validatable, NumericSanitizeable, Focusable)));
export default NumericInputControl;
